<template>
  <Loading />
  <router-view />
</template>
<script>
import Loading from '@/components/Loading.vue';
export default {
  components: {
    Loading
  }
};
</script>